import { render } from "./LogoHorizon.vue?vue&type=template&id=6797c6ce"
const script = {}
script.render = render

export default script